export * from './tax-id-number-format-strategy';
export * from './tax-id-number-length-strategy';
export * from './tax-id-number-logic-strategy';
export * from './tax-id-number-strategy';
